import PropTypes from 'prop-types'

export default PropTypes.shape({
  imoNumber: PropTypes.number.isRequired,
  vesselName: PropTypes.string.isRequired,
})
